import { render, staticRenderFns } from "./StandaloneReleaseInfo.vue?vue&type=template&id=3cd5d448&scoped=true&"
import script from "./StandaloneReleaseInfo.vue?vue&type=script&lang=js&"
export * from "./StandaloneReleaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneReleaseInfo.vue?vue&type=style&index=0&id=3cd5d448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5d448",
  null
  
)

export default component.exports